@if (isLoading) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (!isLoading) {
<div class="md:px-3 lg:px-28 pt-4 bg-white h-full px-4">
  @if (!hasSpecialParams) {
  <div class="py-4 padding-2-5rem-4rem">
    <button class="gap-2 flex items-center" (click)="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="size-6 stroke-[#0D6EFD]">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
      </svg>
      <p class="font-medium text-md text-[#0D6EFD]">
        {{ "PARKIFLY.CONFIRMATION.BOOKING_SUMMARY" | transloco }}
      </p>
    </button>
  </div>
  }
  <div class="Content w-full justify-end items-start gap-8 flex xl:flex-row flex-col pt-0"
    class="padding-2-5rem-4rem py-0">
    <div class="Frame808 flex-col justify-start items-start gap-4 inline-flex w-full">
      <div class="Frame802 self-stretch flex-col justify-start items-start gap-4 flex">
        <div class="DinaUppgifter text-black text-xl font-medium  leading-loose">
          {{'PARKIFLY.CONFIRMATION.UPDATE_BOOKING' | transloco}}
          <span class="font-bold">{{this.bookingNumber}}</span>
        </div>
        <div class="Frame792 self-stretch  rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
          <div class="Frame800 self-stretch justify-start items-start flex flex-col lg:flex-row ">
            @if(this.handleBookingGroup.controls.firstname){
            <div class="Frame795 grow shrink basis-0 h-20 justify-start items-start flex w-full ">
              <div
                class="Frame793 grow rounded-tl-2xl shrink basis-0 pt-3 h-20 lg:border-r border-b border-zinc-200 justify-start items-start gap-2.5 flex">
                <pf-text-input icon="envelope" iconColor="fill-[#9CA3AF]"
                  label="{{'PARKIFLY.FORM.FIRST_NAME' | transloco}}"
                  [inputFormControl]="this.handleBookingGroup.controls.firstname" class="w-full"></pf-text-input>
              </div>
            </div>
            }
            @if(this.handleBookingGroup.controls.lastname){
            <div class="Frame798 grow shrink basis-0 h-20 justify-start items-start flex w-full">
              <div
                class="Frame793 grow rounded-tr-2xl shrink basis-0 h-20 pt-3  border-b border-zinc-200 justify-start items-start gap-2.5 flex">
                <pf-text-input label="{{'PARKIFLY.FORM.LAST_NAME' | transloco}}"
                  [inputFormControl]="this.handleBookingGroup.controls.lastname"
                  class="w-full focus:ring-0">></pf-text-input>
              </div>
            </div>
            }
          </div>
          <div class="Frame800 self-stretch justify-start items-start flex flex-col lg:flex-row ">
            <div class="Frame795 grow shrink basis-0 h-20 justify-start items-start flex w-full ">
              <div
                [ngClass]="{'border-b border-zinc-200' : this.handleBookingGroup.controls.comment, 'rounded-bl-2xl' : !this.handleBookingGroup.controls.comment, 'rounded-tl-2xl' : !this.handleBookingGroup.controls.firstname}"
                class="Frame793 grow shrink basis-0 pt-3 h-20 lg:border-r justify-start items-start gap-2.5 flex">
                <pf-email-input-field icon="envelope" iconColor="fill-[#9CA3AF]"
                  label="{{'PARKIFLY.FORM.EMAIL' | transloco}}"
                  [inputFormControl]="this.handleBookingGroup.controls.email" class="w-full"></pf-email-input-field>
              </div>
            </div>
            <div class="Frame798 grow shrink basis-0 h-20 justify-start items-start flex w-full">
              <div [ngClass]="{'border-b border-zinc-200' : this.handleBookingGroup.controls.comment}"
                class="Frame793 grow shrink basis-0 h-20 pt-3 justify-start items-start gap-2.5 flex">
                <pf-phone-number-input label="{{'PARKIFLY.FORM.PHONENUMBER' | transloco}}"
                  [inputFormControl]="this.handleBookingGroup.controls.cellular"
                  class="w-full focus:ring-0">></pf-phone-number-input>
              </div>
            </div>
          </div>
          @if(this.handleBookingGroup.controls.comment) {
          <div class="Frame801 self-stretch justify-start items-start inline-flex">
            <div class="Frame795 grow shrink basis-0 h-20 justify-start items-start flex">
              <div
                class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                <pf-text-input label="{{'PARKIFLY.FORM.COMMENT' | transloco}}"
                  [inputFormControl]="this.handleBookingGroup.controls.comment"
                  class="w-full focus:ring-0"></pf-text-input>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      <!-- @if(this.handleBookingGroup.controls.arrivalTimeAtParking) {
        <div class="Frame804 self-stretch flex-col justify-start items-start gap-4 flex">
          <div class="DuOchDittResesLlskap text-black text-xl font-medium  leading-loose">{{
          'PARKIFLY.SEARCH.ARRIVAL_TIME' | transloco}}</div>
          <div
            class="Frame792 self-stretch  rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
            <div class="Frame799 self-stretch justify-start items-start flex flex-col lg:flex-row">
              <div
                class="Frame793 grow shrink basis-0 pt-3 h-20 border-zinc-200 justify-start items-start gap-2.5 flex">
                <pf-select [label]="'PARKIFLY.MANAGE_BOOKING.ARRIVAL_TIME' | transloco"
                  [inputFormControl]="this.handleBookingGroup.controls.arrivalTimeAtParking"
                class="w-full" [options]="this.arrivalParkingOptions"></pf-select>
              </div>
            </div>
          </div>
        </div>
        } -->
      <div class="Frame805 self-stretch flex-col justify-start items-start gap-4 flex">
        <div class="Biluppgifter text-black text-xl font-medium  leading-loose">{{'PARKIFLY.DETAILS.CAR_DETAILS'
          |
          transloco}}
        </div>
        <div class="Bagage self-stretch  rounded-xl border border-neutral-300 justify-start items-end inline-flex">
          <div class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
            <pf-text-input (input)="regToUpper()" label="{{'PARKIFLY.FORM.CARID' | transloco}}"
              [inputFormControl]="this.handleBookingGroup.controls.regNr" class="w-full"></pf-text-input>
          </div>
        </div>
      </div>
      <div class="Frame804 self-stretch flex-col justify-start items-start gap-4 flex">
        @if(this.handleBookingGroup.controls.contact) {
        <div class="DuOchDittResesLlskap text-black text-xl font-medium  leading-loose">
          {{'PARKIFLY.MANAGE_BOOKING.CONTACT_US' |
          transloco}}</div>
        <div class="Frame792 self-stretch  rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
          <div class="Frame799 self-stretch justify-start items-start flex flex-col lg:flex-row">
            <div
              class="Frame793 grow shrink basis-0 flex items-center px-3 pl-3 h-20 border-zinc-200 justify-start items-start gap-2.5 flex">
              <app-radio-btn class="margin-top-neg-15px" [inputFormControl]="this.handleBookingGroup.controls.contact"
                [options]="[{ value: 'true', viewValue: 'PARKIFLY.MANAGE_BOOKING.YES' | transloco }, { value: 'false', viewValue: 'PARKIFLY.MANAGE_BOOKING.NO' | transloco }]"
                value="false"></app-radio-btn>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  <div>
    <div class="pt-4 pb-8 md:pt-8 md:flex md:justify-start md:flex-row-reverse gap-2 padding-2-5rem-4rem">
      <button
        class="w-full px-8 py-3 bg-[#1B3777] hover:bg-[#1B3777] rounded-[4px] font-medium text-md leading-6 flex justify-center md:mb-0 md:w-auto mb-4 md:mb-0 text-[#FFFFFF] disabled:bg-[#dcdcdc] disabled:text-[#4B4A4A] disabled:cursor-not-allowed disabled:opacity-70"
        (click)="updateBooking()" [disabled]="!formHasChanges || isLoading">
        {{ 'PARKIFLY.MANAGE_BOOKING.UPDATE_BOOKING' | transloco }}
      </button>
      @if(booking?.orderStatus == "Checkout" || booking?.orderStatus == "CheckoutAdditional" ||
      booking?.orderStatus == "DriveUp") {
      <button
        class="w-full px-8 py-3 bg-[#1B9320] hover:bg-[#1B9320] rounded-[4px] font-medium text-md leading-6 flex justify-center md:mb-0 md:w-auto mb-4 md:mb-0"
        (click)="goToPaymentPage()" class="text-white">
        {{ 'PARKIFLY.MANAGE_BOOKING.COMPLETE_PAYMENT' | transloco }}
      </button>
      }
    </div>
  </div>
</div>
}